import { Button } from "@/components/ui/button";
import { ClipboardList } from "lucide-react";
import { InventoryModeDialog } from "./InventoryModeDialog";
import { InventoryValidationDialog } from "./InventoryValidationDialog";
import { InventoryGrid } from "./InventoryGrid";
import { InventoryHeader } from "./InventoryHeader";
import { InventoryHistoryList } from "./InventoryHistoryList";
import { useInventoryManagement } from "./hooks/useInventoryManagement";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

interface InventoryModeProps {
  stockItems: any[];
  onInventoryComplete: () => void;
  onInventoryStart: () => void;
  isInventoryActive: boolean;
  renderActions: (isActive: boolean) => React.ReactNode;
  buttonVisibility?: {
    inventory?: boolean;
  };
}

export const InventoryMode = ({ 
  stockItems = [],
  onInventoryComplete,
  onInventoryStart,
  renderActions,
  buttonVisibility = { inventory: true }
}: InventoryModeProps) => {
  const {
    isActive,
    selectedItem,
    isDialogOpen,
    setIsDialogOpen,
    isValidationOpen,
    setIsValidationOpen,
    inventoryData,
    searchQuery,
    setSearchQuery,
    currentPage,
    setCurrentPage,
    progress,
    currentItems,
    totalPages,
    handleStartInventory,
    handleCancelInventory,
    handleItemClick,
    handleConfirmCount,
    handleFinishInventory,
    handleValidateInventory,
  } = useInventoryManagement({
    onInventoryComplete,
    onInventoryStart,
    stockItems,
  });

  if (!isActive) {
    return (
      <div className="flex flex-col gap-4 w-full">
        <Tabs defaultValue="current" className="w-full">
          <TabsList>
            <TabsTrigger value="current">Inventaire actuel</TabsTrigger>
            <TabsTrigger value="history">Historique</TabsTrigger>
          </TabsList>
          
          <TabsContent value="current">
            {buttonVisibility.inventory && (
              <Button 
                onClick={handleStartInventory}
                className="bg-purple-600 hover:bg-purple-700 w-fit"
              >
                <ClipboardList className="mr-2 h-4 w-4" />
                Démarrer l'inventaire
              </Button>
            )}
            <div className="flex justify-between w-full">
              {renderActions(false)}
            </div>
          </TabsContent>
          
          <TabsContent value="history">
            <InventoryHistoryList />
          </TabsContent>
        </Tabs>
      </div>
    );
  }

  return (
    <div className="space-y-4 w-full">
      <InventoryHeader
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        progress={progress}
        handleFinishInventory={handleFinishInventory}
        setIsActive={handleCancelInventory}
        inventoryData={inventoryData}
      />

      {renderActions(true)}

      <InventoryGrid
        currentItems={currentItems}
        handleItemClick={handleItemClick}
        inventoryData={inventoryData}
        totalPages={totalPages}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      />

      <InventoryModeDialog
        open={isDialogOpen}
        onOpenChange={setIsDialogOpen}
        selectedItem={selectedItem}
        onConfirm={handleConfirmCount}
      />

      <InventoryValidationDialog
        open={isValidationOpen}
        onOpenChange={setIsValidationOpen}
        inventoryData={inventoryData}
        onValidate={handleValidateInventory}
      />
    </div>
  );
};